import createUseContextStore from "src/stores/createUseContextStore";
import EditCoverGalleryContext from "../contexts/EditCoverGalleryContext";
import { EditCoverGalleryStore } from "../stores/editCoverGalleryStore";

const useEditCoverGalleryStore = createUseContextStore<EditCoverGalleryStore>()(
	EditCoverGalleryContext,
	(context) => context.store,
);
export default useEditCoverGalleryStore;
